export default {"src":"/_next/static/media/webtrixLogoSBijelimTextom.be3fb4aa.svg","height":361,"width":432,"blurWidth":0,"blurHeight":0};